<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-product modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ค้นหาคลังสินค้าของร้านค้า</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="filter form">
                            <stock-lookup-filter :isSmall="true" @lookup="filterStockList($event)"></stock-lookup-filter>
                        </div>

                        <div class="mt-3" v-if="inventoryList.length > 0">
                            <perfect-scrollbar>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>สินค้า</th>
                                            <th>ราคา</th>
                                            <th v-if="isShowQuantity">เหลือสต๊อค</th>
                                            <th v-if="isShowQuantity">จำนวนการสั่งซื้อ</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in inventoryList" :key="index">
                                            <td>
                                                <span class="text-nowrap" v-if="item.inventoryData.sku">SKU: {{ item.inventoryData.sku }}</span>
                                                {{ item.productData.name }}
                                            </td>
                                            <td>{{ appHelper.getCommaNumber(item.inventoryData.price) }}</td>
                                            <td v-if="isShowQuantity">
                                                <div class="stock">
                                                    <label>คงเหลือ (ของร้าน)</label>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountNormal')) }}
                                                </div>
                                                <div class="stock">
                                                    <label>คงเหลือ (สินค้าโป๊ว)</label>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountSublet')) }}
                                                </div>
                                                <div class="stock">
                                                    <label>คงเหลือ (ฝากขาย)</label>{{ appHelper.getCommaNumber($AppUtility.getAvailableStock(item.stockData, 'amountConsign')) }}
                                                </div>
                                                <div class="stock">
                                                    <label>ถูกจอง</label>{{ appHelper.getCommaNumber(item.stockData.reserve) }}
                                                </div>
                                            </td>
                                            <td v-if="isShowQuantity">
                                                <div class="input-quantity">
                                                    <button class="btn btn-secondary btn-decrease" @click="adjustQty(item, -1)">-</button>
                                                    <div class="input-field">{{ item.quantity }}</div>
                                                    <button class="btn btn-secondary btn-increase" @click="adjustQty(item, 1)">+</button>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="text-center">
                                                    <button class="btn btn-sm btn-blue text-nowrap btn-product-select" @click="addProduct(item)">จองสินค้าเข้ารายการ</button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </perfect-scrollbar>

                            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="inventoryList.length" class="mt-4"></paging>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <div class="mt-3 no-data" v-if="isNotFound">
                            <b-icon icon="exclamation-diamond"></b-icon>
                            <span>ไม่พบสินค้าที่กำลังตามหาในร้าน โปรดทำการใส่ข้อมูลสินค้าเพิ่มลงในระบบสต๊อค</span>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import StockLookupFilter from '@/components/utility/StockLookupFilter';
import Helper from '@/resources/Helper';
import DBInventory from '@/database/Inventory';
import DBStock from '@/database/Stock';
import DBMasterProduct from '@/database/MasterProduct';
import ModelStockFilter from '@/resources/models/StockFilter';

export default {
    components: {
        StockLookupFilter
    },
    data() {
        return {
            isActive: false,
            isNotFound: false,
            inventoryList: [],
            inventoryFilter: ModelStockFilter.data(),
            isLoading: false,
            activePage: 1,
            pageSize: 10,
            appHelper: Helper
        };
    },
    props: {
        isDisplay: Boolean,
        isShowQuantity: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.initStockField();
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        initStockField() {
            this.isNotFound = false;
            this.inventoryList = [];
        },
        filterStockList(value) {
            this.inventoryFilter = value;
            this.loadInventoryList();
        },
        async loadInventoryList() {
            this.isLoading = true;
            this.initStockField();

            // Sync Master Data
            await DBMasterProduct.sync();

            // Load Inventory Data
            const inventory = await DBInventory.get();
            const stock = await DBStock.get();

            if (inventory.content && inventory.content.length > 0) {
                // Merge Object
                let result = this.mergeObject(inventory.content, stock.content);

                // Filter Result
                result = await this.$AppUtility.inventoryFilterResult(result, this.inventoryFilter);

                if (result.length > 0) {
                    // Map and Place into the Object
                    this.inventoryList = await this.mapViewData(result);
                } else {
                    this.isNotFound = true;
                }
            } else {
                this.isNotFound = true;
            }

            this.isLoading = false;
        },
        isConsignProduct(stock) {
            if (stock.dots.filter(x => x.amountConsign > 0).length > 0) {
                return true;
            }

            return false;
        },
        mergeObject(inventoryList, stockList) {
            let result = [];

            inventoryList.forEach((inventory) => {
                const stock = stockList.find(x => x.key === inventory.key);
                const obj = inventory;

                obj['stockData'] = {
                    dots: stock.dots,
                    reserve: stock.reserve
                };

                result.push(obj);
            });

            return result;
            
        },
        async mapViewData(content) {
            const data = [];

            for (const item of content) {
                data.push({
                    inventoryKey: item.key,
                    productData: item.productData,
                    inventoryData: item.inventoryData,
                    stockData: item.stockData,
                    quantity: item.productData.productCategory === this.$Constants.CATEGORY_TIRE && this.isShowQuantity ? 4 : 1
                });
            }

            return data;
        },
        addProduct(item) {
            this.$emit('addProduct', item);
        },
        adjustQty(item, qty) {
            item.quantity = item.quantity + qty;

            if (item.quantity < 0) {
                item.quantity = 0;
            }
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-product {
    max-width: 1000px;

    table {
        td {
            vertical-align: top;

            .stock {
                display: flex;
                align-items: center;
                font-size: 12px;
                white-space: nowrap;

                label {
                    margin: 0 15px 0 0;
                    opacity: 0.7;
                }
            }

            .btn-product-select {
                width: 125px;
            }
        }
    }
}
</style>